import { supabase } from "@/lib/supabase";

export const signInWithEmail = async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
    });
    if (error) throw error;
    return data;
};

// Kicks off the Google OAuth flow. supabase-js has detectSessionInUrl on by
// default, so the PKCE code is exchanged automatically when Google redirects
// back to the app root — AuthProvider then picks up the session and runs the
// approval check, so no dedicated callback route is needed.
export const signInWithGoogle = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: { redirectTo: `${window.location.origin}/` }
    });
    if (error) throw error;
};

export const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
};

export const getSession = async () => {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    return data.session;
};

export const getUser = async () => {
    const { data, error } = await supabase.auth.getUser();
    if (error) throw error;
    return data.user;
};

// Authorization header for our own serverless endpoints (e.g. the LLM import
// routes), which verify the caller's Supabase session before doing any work.
// Returns an empty object when there's no session so callers can spread it
// unconditionally; the request will then be rejected server-side with a 401.
export const getAuthHeader = async (): Promise<Record<string, string>> => {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
};
